import { useEffect, useRef } from "react";
import { useAppSelector } from "../utils/hooks";
import Cookies from "js-cookie";

const OneSignalInit: React.FC = () => {
  const userData = useAppSelector((state) => state.userData);
  const initRef = useRef(false);

  useEffect(() => {
    const appId = import.meta.env.VITE_ONE_SIGNAL_APP_ID;
    const token = Cookies.get("whoxa_web_token");
    if (!appId || !token || initRef.current) return;

    const doInit = async (OneSignal: any) => {
      if (initRef.current) return;
      initRef.current = true;
      try {
        const safariWebId = import.meta.env.VITE_ONE_SIGNAL_SAFARI_WEB_ID;
        await OneSignal.init({
          appId,
          ...(safariWebId && { safari_web_id: safariWebId }),
          allowLocalhostAsSecureOrigin: import.meta.env.DEV,
          notifyButton: { enable: false }, // своя модалка EnableNotificationsModal
          serviceWorkerPath: "OneSignalSDKWorker.js",
          welcomeNotification: { disable: true }, // убираем дубли "Thanks for subscribing!"
          // Chrome desktop: false = уведомления исчезают через короткое время
          persistNotification: false,
        });
        if (userData?.user_id) {
          await OneSignal.login(`user_${userData.user_id}`).catch(() => {});
        }
      } catch {
        // App not configured for web push — игнорируем, пока Web не настроен в OneSignal Dashboard
      }
    };

    const run = (OS: any) => doInit(OS).catch(() => {});
    if ((window as any).OneSignal) {
      run((window as any).OneSignal);
    } else {
      (window as any).OneSignalDeferred = (window as any).OneSignalDeferred || [];
      (window as any).OneSignalDeferred.push(run);
    }
  }, [userData?.user_id]);

  return null;
};

export default OneSignalInit;
